<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>نحوه پرداخت اقساط کلینیک یاس   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="container text-right my-2" >
                <template #default>خرید اقساطی به عنوان یک گزینه مناسب برای افرادی که نمی‌توانند هزینه‌های دندان‌پزشکی را به صورت یکجا پرداخت کنند، در کلینیک دندان‌پزشکی یاس ارائه می‌شود. مراحل خرید اقساطی شامل مشاوره اولیه برای ارزیابی وضعیت دندانی، دریافت برآورد هزینه کل درمان، انتخاب گزینه‌های اقساطی، تکمیل مدارک لازم مثل کارت ملی و شناسنامه، امضای قرارداد و شروع فرآیند درمان است.برای راحت کردن کار بیماران جهت بازنشستگان با موسسه وام بانک رفاه (میلان قسط) و موسسه مالی استحکام قرارداد داریم در صورت نیاز به وام میتونیم برایتان معرفی نامه صادر کنیم.   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="container text-right my-2" >
                <template #default>شرایط پرداخت اقساطی شامل مدت زمان اقساط، نرخ سود (در صورت وجود) و الزامات پرداخت اولیه می‌باشد. با این روش، شما می‌توانید بدون نگرانی از هزینه‌های سنگین درمان دندان‌پزشکی، به بهبود سلامت دهان و دندان خود بپردازید. برای اطلاعات بیشتر و شروع مراحل، می‌توانید با کلینیک دندان‌پزشکی یاس تماس بگیرید.   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-products-308 v-bind='{...{"paginate":"true","perPage":12,"productCardName":"mProductCard505","showSpecifiedCardFeature":"","cardWrapperCLass":""},...{}}' :style='""' class="" ></m-products-308></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-shopping-cart-2 v-bind='{...{"haveItem":"https:\/\/api.mizline.ir\/storage\/contents\/shopping-cart-icon-512x462-yrde1eu0.png","empty":"https:\/\/api.mizline.ir\/storage\/contents\/shopping-cart-icon-512x462-yrde1eu0.png"},...{}}' :style='"\n"' class="sticky-shopping" ></m-shopping-cart-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mProducts308 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products308/Products308'; import mShoppingCart2 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mP,mProducts308,mShoppingCart2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
